/**
 * Created by matheusmorett on 11/06/18.
 */
import React, { Component } from 'react';

import createBrowserHistory from 'history/createBrowserHistory';
import { Provider } from 'mobx-react';
import { Router, Route } from 'react-router-dom';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
// import { enableLogging } from 'mobx-logger';

//theme
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import createPalette from '@material-ui/core/styles/createPalette';

//router
import RouterComp from './router';

//stores
import { AuthStore } from 'modules/auth/AuthStore';
import { AdventureStore } from 'modules/adventure/AdventureStore';
import SelectedPackageDataStore from 'adventureModules/packageData/SelectedPackageDataStore';
import { RequestsStore } from 'modules/reservations/RequestsStore';
import ScheduleRuleStore from 'modules/schedule/ScheduleRuleStore'
import DashboardStore from 'modules/dashboard/DashboardStore';
import FinancesStore from 'modules/finances/FinancesStore';
import { SiteProviderStore } from 'modules/site/SiteProviderStore';

//global stores
import NotificationStore from 'stores/NotificationStore';
import DrawerStore from 'stores/DrawerStore';
import CompanyStore from 'stores/CompanyStore';

//utils
import moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('pt-br')

export const Navigator = new RouterStore();

const history = syncHistoryWithStore(
  createBrowserHistory({}), Navigator
);

const stores = {
  //router
  Navigator,

  //modules
  AuthStore,
  AdventureStore,
  SelectedPackageDataStore,
  RequestsStore,
  FinancesStore,
  DashboardStore,
  ScheduleRuleStore,
  SiteProviderStore,

  //globals
  NotificationStore,
  DrawerStore,
  CompanyStore
};


const theme = createMuiTheme({
  typography: {
    fontFamily: '"ZonaPro", serif',
  },
  overrides: {
    // MuiTypography: {
    //   title: {
    //     fontWeight: 700,
    //     fontSize: '18px'
    //   }
    // },
    MuiButton: {
      //overrides all button css flat and raised
      root: {
        margin: '5px'
      }
    },
    // MuiFormLabel: {
    //   root: {
    //     color: '#f50673 !important',
    //   }
    // },
    // MuiInput: {
    //   underline: {
    //     '&:hover:not($disabled):before': { //underline color when hovered
    //       borderBottom: '2px solid #f50673',
    //     },
    //     '&:hover:not($disabled):after': { //underline color when hovered
    //       borderBottom: '2px solid #f50673',
    //     },
    //   }
    // }
  },
  palette: createPalette({
    primary: {
      light: '#a0a0a0',
      main: '#212121',
      dark: '#000000',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#ff5ca1',
      main: '#f50673',
      dark: '#bc0048',
      contrastText: '#ffffff',
    },
    error: {
      main: '#ff4400',
    },
    textSecondary: {
      main: '#cccccc',
    },
  })
});

class index extends Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Provider {...stores}>
          <Router history={history}>
            <Route component={RouterComp} />
          </Router>
        </Provider>
      </MuiThemeProvider>
    );
  }
}

export default index;


// WEBPACK FOOTER //
// ./src/router/index.js